import styled from 'styled-components'

import { AbsolutePositioning } from 'components/common/genericStyles'

import { modalWidth, padding } from './constants'

export const Container = styled.div`
    background: #36383c;
    width: ${modalWidth}px;
    height: 312px;
    padding: ${padding}px;

    ${AbsolutePositioning}

    border-radius: 8px;
    box-shadow: 0px 8px 24px rgb(17 17 26 / 6%),
        0px 12px 32px rgb(17 17 26 / 6%);
    z-index: 99;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-evenly;

    cursor: default;
`

export const Overlay = styled.div`
    ${AbsolutePositioning}
    height: 100vh!important;
    width: 100vw !important;
    background: #36383c94;
    z-index: 99;
`

export const Row = styled.div`
    width: 100%;
    display: flex;
    justify-content: ${props =>
        props.flexStart ? 'flex-start' : 'space-evenly'};
`

export const Close = styled.img`
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
`
